import { render, staticRenderFns } from "./addemployeecredit.vue?vue&type=template&id=6119b961&"
import script from "./addemployeecredit.vue?vue&type=script&lang=js&"
export * from "./addemployeecredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports